var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"interactive-editor-page grey lighten-4"},[_c('app-bar'),(_vm.isLoggedIn)?_c('left-drawer'):_vm._e(),_c('keep-alive',{attrs:{"include":['uploadPage']}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }